import type { RouteObject } from "react-router-dom";
import NotFound from "@/pages/NotFound";
import Home from "@/pages/home/page";
import ArticlePage from "@/pages/article/page";
import SafetyGuidePage from "@/pages/safety/page";
import ShippingGuidePage from "@/pages/shipping/page";
import CategoriesGuidePage from "@/pages/categories/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/superbuy-spreadsheet-guide",
    element: <ArticlePage />,
  },
  {
    path: "/superbuy-spreadsheet-safety-guide",
    element: <SafetyGuidePage />,
  },
  {
    path: "/superbuy-spreadsheet-shipping-guide",
    element: <ShippingGuidePage />,
  },
  {
    path: "/superbuy-spreadsheet-categories",
    element: <CategoriesGuidePage />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;